module.exports = __webpack_public_path__ + "media/mfg/buyingShows-ccb46c0c.jpg";